<script setup lang="ts">
import { StaticMap, MapType } from '../../../maps';
import { useActivityDetailsDescriptionStore } from '../../stores/activityDetailsDescriptionStore';
import { useActivityDetailsMapStore } from '../../stores/activityDetailsMapStore';
import ActivityDetailsHeader from '../ActivityDetailsHeader.vue';
import { useActivityDetailsStore } from '../../stores/activityDetailsStore';
import ActivityDetailsMapLoader from '../loaders/ActivityDetailsMapLoader.vue';
import ActivityDescriptionDistancesLoader from '../loaders/ActivityDescriptionDistancesLoader.vue';
import ActivityDescriptionFacilitiesLoader from '../loaders/ActivityDescriptionFacilitiesLoader.vue';
import ActivityDescriptionTagsLoader from '../loaders/ActivityDescriptionTagsLoader.vue';
import ActivityMainDescriptionLoader from '../loaders/ActivityMainDescriptionLoader.vue';
import ActivityDetailsHeaderLoader from '../loaders/ActivityDetailsHeaderLoader.vue';

import ActivityDescriptionTags from './ActivityDescriptionTags.vue';
import ActivityDescriptionDistances from './ActivityDescriptionDistances.vue';
import ActivityDescriptionFacilities from './ActivityDescriptionFacilities.vue';
import ActivityMainDescription from './ActivityMainDescription.vue';

interface ActivityDetailsDescriptionProps {
  isLoading: boolean;
}

const props = defineProps<ActivityDetailsDescriptionProps>();

const activityDetailsDescriptionStore = useActivityDetailsDescriptionStore();
const activityDetailsMapStore = useActivityDetailsMapStore();
const activityDetailsStore = useActivityDetailsStore();
</script>

<template>
  <div class="activity-details-description">
    <div class="left-column">
      <ActivityDetailsHeaderLoader v-if="props.isLoading" />
      <ActivityDetailsHeader
        v-else-if="activityDetailsStore.headerData"
        :header-data="activityDetailsStore.headerData"
      />
      <ActivityDescriptionTagsLoader v-if="props.isLoading" />

      <ActivityDescriptionTags
        v-else-if="activityDetailsDescriptionStore.tagsUrls"
        :tag-img-urls="activityDetailsDescriptionStore.tagsUrls"
      />
      <ActivityDescriptionFacilitiesLoader v-if="props.isLoading" />

      <ActivityDescriptionFacilities
        v-else-if="activityDetailsDescriptionStore.facilities"
        :facilities="activityDetailsDescriptionStore.facilities"
      />
      <ActivityMainDescriptionLoader v-if="props.isLoading" />

      <ActivityMainDescription
        v-else-if="activityDetailsDescriptionStore.mainDescription"
        :description="activityDetailsDescriptionStore.mainDescription"
        :button-text="activityDetailsDescriptionStore.buttonText"
        @toggle-full-description="
          activityDetailsDescriptionStore.toggleFullDescription
        "
      />
    </div>
    <div class="right-column">
      <ActivityDescriptionDistancesLoader v-if="props.isLoading" />
      <ActivityDescriptionDistances
        v-else-if="activityDetailsDescriptionStore.distances"
        :distances="activityDetailsDescriptionStore.distances"
      />

      <ActivityDetailsMapLoader v-if="props.isLoading" />
      <StaticMap
        v-else
        :map-configuration="{
          markers: activityDetailsMapStore.mapMarker,
          markerFormatters: activityDetailsMapStore.getMapMarkerFormatters(
            MapType.Static
          ),
          startRectangle: activityDetailsMapStore.initialMapView,
        }"
        @zoom="activityDetailsMapStore.openDynamicMapModal"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.activity-details-description {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;

  @include for-less-or-equal-than-599-px {
    grid-template-columns: auto;
    grid-template-rows: repeat(2, min-content);
  }

  .left-column {
    grid-column: 1 / span 7;
    padding: var(--spacing-32) 0;

    @include for-less-or-equal-than-599-px {
      padding: var(--spacing-16);
      grid-column: 1;
    }
  }

  .right-column {
    grid-column: 8 / -1;

    padding: var(--spacing-32) var(--spacing-24);

    @include for-less-or-equal-than-599-px {
      padding: var(--spacing-16);
      grid-column: 1;
    }
  }
}
</style>
